import { Directive, input } from '@angular/core';

@Directive({
  selector: '[appAiBorder]',
  host: {
    class: 'app-ai-border',
    '[style.opacity]': 'visible() ? null : 0',
    '[style.--ai-border-radius]': 'radius() ?? null',
    '[style.--ai-border-inset]': 'inset() ?? null',
    '[style.--ai-border-thickness]': 'thickness() ?? null',
    '[style.--ai-border-duration]': 'duration() ?? null',
    '[style.--ai-border-fade-duration]': 'fadeDuration() ?? null',
    '[style.--ai-border-color-1]': 'colorStart() ?? null',
    '[style.--ai-border-color-2]': 'colorEnd() ?? null',
  },
})
export class AiBorderDirective {
  readonly visible = input<boolean>(true);
  readonly radius = input<string | undefined>(undefined);
  readonly inset = input<string | undefined>(undefined);
  readonly thickness = input<string | undefined>(undefined);
  readonly duration = input<string | undefined>(undefined);
  readonly fadeDuration = input<string | undefined>(undefined);
  readonly colorStart = input<string | undefined>(undefined);
  readonly colorEnd = input<string | undefined>(undefined);
}
